import {event} from "./functions";
event('input[type="file"]', 'change', function(e){
    let file = this.value;
    let split = file.split('\\');
    this.parentNode.parentNode.querySelector('.file-name').innerHTML = 'Имя файла: ' + split[split.length-1];
});
